// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2nKRI","title":"InfoRow_title__2FDLm"};